import type { FaireProductEntity } from "../../entity_types/product";

export const p_xp9u3sm9dx: FaireProductEntity = {
  token: "p_xp9u3sm9dx",
  type: "product",
  name: "Vintage Lined Notebook Greetings from the Desert - Paperback",
  brandToken: "b_4d6jvdz5w2",
  brandName: "Books by splitShops",
  imageUrl: "https://cdn.faire.com/fastly/cac41a41edc93554495a401f5f4984f8bc32a71f41f9dd38c04e3caa8a7ee7f7.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.51,
  description: "\nby Found Image Press (Producer)\n\nIntroducing the Vintage Notebook: Greetings from the Desert, a delightful companion for all your writing endeavors. Featuring 150 lined pages, immerse yourself in the charm of a classic vintage travel postcard illustration adorning its cover. With its full-color decorative vintage art and versatile functionality, this notebook is an ideal companion for journaling, planning trips, tackling writing projects, organizing to-do lists, or simply capturing thoughts on any occasion. Found Image Press Vintage Journals take you on a nostalgic journey, featuring carefully curated vintage art that celebrates your favorite places, hobbies, and interests.",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:55.466Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
